import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import axios from 'axios'
import md5 from 'js-md5'
import "./css/global.css"
import wtySelect from '@/components/wty-select';
//引入vuex
import store from "./store";
//引入less
import less from 'less';
//引入字体
import './assets/fonts/fonts.css';

//通用函数
import common from './js/common.js';
// import { MessageBox } from 'element-ui'
import './assets/icon/iconfont.css';
//引入rsa
import Rsa from "@/js/Rsa.js";
// 打印机组件的导入
import Print from 'vue-print-nb';
Vue.component('wtySelect', wtySelect);

//引入外部icon
// import './assets/icon/iconfont.css'
//使用less
Vue.use(less);

//使用通用函数
Vue.use(common);

//绑定rsa加密到vue原型
Vue.prototype.$Rsa = Rsa;

//使用打印机
Vue.use(Print);

/* eslint-disable */
// esay-table的使用
import "vue-easytable/libs/theme-default/index.css";
import VeTable from "vue-easytable";
Vue.use(VeTable);
import { VeLocale } from "vue-easytable";
// import language esaytable 使用中文
import zhCN from "vue-easytable/libs/locale/lang/zh-CN";
VeLocale.use(zhCN);

Vue.prototype.$url = "https://api.hakspay.cn/";
// Vue.prototype.$url = "https://api.easy.haeasy.net/"
Vue.prototype.$http = axios;
Vue.config.productionTip = false;
// 挂载md5
Vue.prototype.$md5 = md5;

Vue.prototype.appid = "wxeb0785b658dcbead";




console.log("🍻");







let devVue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
export default devVue